module.exports = __webpack_public_path__ + "static/media/PR7.c872900c.jpg";